import React from 'react';
import { bugsnagClient } from './initObservability';

export const ErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  const BugsnagReactPlugin = bugsnagClient.getPlugin('react');
  const BugsnagPlugin = BugsnagReactPlugin ? BugsnagReactPlugin.createErrorBoundary(React) : null;

  if (!BugsnagPlugin) {
    return <>{children}</>;
  }

  return <BugsnagPlugin>{children}</BugsnagPlugin>;
};
